var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('CodeInput',{staticClass:"input",attrs:{"loading":false},on:{"change":_vm.onChange,"complete":_vm.onComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }